var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftGuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.257,
    height: 118.83,
    viewBox: "0 0 119.257 118.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svgicon-gift-guy-a{fill:#f3f3f3;opacity:0.9;}.svgicon-gift-guy-b{fill:#f5f5f5;}.svgicon-gift-guy-c{fill:#01c6d9;}.svgicon-gift-guy-d{opacity:0.2;}.svgicon-gift-guy-e{fill:#263238;}.svgicon-gift-guy-f{opacity:0.5;}.svgicon-gift-guy-g{fill:#ff8b7b;}.svgicon-gift-guy-h{fill:#fff;}.svgicon-gift-guy-i{fill:#ff5652;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.978 -55.063)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.978 55.063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-a",
    d: "M41.38,15.1c14.981-8.268,41.526-30.149,50.025,1.443C99.84,47.909,69.245,71.83,51.994,75.1,34.557,78.4-8.12,62.7,1.356,30.354,7.875,8.109,24.836,24.217,41.38,15.1Z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 0, 64.497)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.306 158.548)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "svgicon-gift-guy-b",
    cx: 51.512,
    cy: 3.007,
    rx: 51.512,
    ry: 3.007,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.614 87.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "svgicon-gift-guy-c",
    width: 0.266,
    height: 3.571,
    transform: "translate(0.064 40.245)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "svgicon-gift-guy-c",
    width: 0.266,
    height: 1.477,
    transform: "translate(0.064 44.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M79.83,240.77h43.446v46.618h-42.2a1.241,1.241,0,0,1-1.241-1.241V240.77Z",
    transform: "translate(-78.836 -213.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M123.276,240.77H79.83v3.305h25l.829,43.313.579-43.313h17.04Z",
    transform: "translate(-78.836 -213.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M76.709,214.1H120.53v9.447H76.709a.619.619,0,0,1-.619-.619v-8.207a.619.619,0,0,1,.619-.622Z",
    transform: "translate(-76.09 -193.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M141.544,267.8l-.454-53.7h9.447l.452,53.7Z",
    transform: "translate(-123.821 -193.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M1.233,0H18.345V46.618H0V1.241A1.241,1.241,0,0,1,1.233,0Z",
    transform: "translate(62.795 73.813) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M1.233,0H18.345V46.618H0V1.241A1.241,1.241,0,0,1,1.233,0Z",
    transform: "translate(62.795 73.813) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M243.36,240.77h18.353v3.305H251.471l-1.392,43.313.151-43.313h-6.87Z",
    transform: "translate(-198.92 -213.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M.619,0h18.73V9.447H.619A.619.619,0,0,1,0,8.828V.622A.619.619,0,0,1,.619,0Z",
    transform: "translate(63.789 29.557) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M.619,0h18.73V9.447H.619A.619.619,0,0,1,0,8.828V.622A.619.619,0,0,1,.619,0Z",
    transform: "translate(63.789 29.557) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M268.65,267.8l.792-53.7h5.9l-.792,53.7Z",
    transform: "translate(-217.491 -193.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M268.65,267.8l.792-53.7h5.9l-.792,53.7Z",
    transform: "translate(-217.491 -193.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M218.481,146.963v-.013h-7.729a3.624,3.624,0,0,0-1.281.351c-7.837,3.284-11.647,11.889-13.332,17.479h7.907S222.758,146.432,218.481,146.963Z",
    transform: "translate(-164.246 -144.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-f",
    d: "M225.9,164.816c0-7.261,5.494-14.2,13.332-17.479S225.9,164.816,225.9,164.816Z",
    transform: "translate(-186.099 -144.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M227.828,164.286h-5.736a3.454,3.454,0,0,0-1.063.266c-6.759,2.439-12.054,8.828-14.91,12.978h5.871S231.157,163.888,227.828,164.286Z",
    transform: "translate(-171.574 -157.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-f",
    d: "M228.26,177.505c2.766-7.173,8.151-10.539,14.91-12.978S228.26,177.505,228.26,177.505Z",
    transform: "translate(-187.832 -157.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M118.105,138.426v-.016h-7.747a.8.8,0,0,0-.7.4c-2.418,3.7,7.97,13.406,15.523,19.711h7.907S121.5,137.822,118.105,138.426Z",
    transform: "translate(-100.475 -138.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-f",
    d: "M154.938,158.524c-7.543-6.3-17.941-16.01-15.523-19.711S154.938,158.524,154.938,158.524Z",
    transform: "translate(-122.329 -138.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M153.524,157.972h-5.749a.816.816,0,0,0-.606.292c-2.561,2.75,3.146,9.958,7.439,14.636h5.863S156.168,157.51,153.524,157.972Z",
    transform: "translate(-127.817 -152.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-f",
    d: "M176.676,172.831c-4.293-4.681-10-11.886-7.439-14.636S176.676,172.831,176.676,172.831Z",
    transform: "translate(-144.021 -152.722)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.034 79.578)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M381.818,386.309l2.03-.656-.978-4.872-2.03.654Z",
    transform: "translate(-356.295 -308.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M323.93,394.389h2.131l.569-4.939H324.5Z",
    transform: "translate(-314.504 -314.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M324.1,407.109h-2.6a.178.178,0,0,0-.175.146l-.337,1.9a.327.327,0,0,0,.327.377c.837-.013,1.445-.064,2.5-.064.648,0,2.6.069,3.5.069s.975-.885.606-.967a8.622,8.622,0,0,1-3.454-1.328.531.531,0,0,0-.364-.13Z",
    transform: "translate(-312.342 -327.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M385.334,398.1l-2.218.728a.186.186,0,0,0-.128.194l.181,1.934a.311.311,0,0,0,.409.266c.8-.266,1.937-.691,2.941-1.015,1.174-.38,1.873-.571,3.249-1.018.834-.266.8-1.185.42-1.148-1.7.165-2.657.476-4.315.072A.956.956,0,0,0,385.334,398.1Z",
    transform: "translate(-357.871 -320.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M343.356,164.48c.266.6.563,1.243.861,1.86s.6,1.241.919,1.846.632,1.214.972,1.8.685,1.156,1.049,1.706c.186.266.367.531.563.781l.29.369a1.617,1.617,0,0,0,.178.2.916.916,0,0,0,.332.223,1.2,1.2,0,0,0,.531.048,4.338,4.338,0,0,0,1.533-.59c.266-.154.531-.332.8-.518s.531-.4.776-.584l1.233,1.018a8.821,8.821,0,0,1-.7.954,8.532,8.532,0,0,1-.816.858,6.819,6.819,0,0,1-.983.765,4.988,4.988,0,0,1-1.243.59,3.648,3.648,0,0,1-1.594.146,3.568,3.568,0,0,1-1.594-.627,4.515,4.515,0,0,1-.606-.518l-.4-.441c-.266-.292-.5-.6-.749-.9a30.388,30.388,0,0,1-2.418-3.765c-.353-.646-.691-1.294-1-1.955s-.619-1.31-.906-2.019Z",
    transform: "translate(-326.584 -149.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M336.781,159.847c-.38,2,2.107,4.862,2.107,4.862l3.653-1.573a8.945,8.945,0,0,0-1.838-3.948C338.914,157.161,337.2,157.669,336.781,159.847Z",
    transform: "translate(-323.912 -144.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M338.8,167.237a2.2,2.2,0,0,0-2,0c.181,1.9,2.125,4.145,2.125,4.145l2.588-1.113A4.655,4.655,0,0,0,338.8,167.237Z",
    transform: "translate(-323.955 -151.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M383.55,186.258l1.166-2.457,1.637,1.711s-.465,1.961-2,1.711Z",
    transform: "translate(-358.285 -163.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M388.875,179.45l1.267,1.57-.566,1.3-1.637-1.711Z",
    transform: "translate(-361.508 -160.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M382.87,380.78l.5,2.513-2.032.654-.5-2.511Z",
    transform: "translate(-356.295 -308.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M325.245,389.46h2.133l-.292,2.545H324.95Z",
    transform: "translate(-315.253 -314.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M300.87,159.751c3.074,7.84,3.454,16.443,3.826,18.154l11.241-1.95c.266-10.6-2.391-16.451-3.1-17.824a.637.637,0,0,0-.531-.343c-.314-.021-.8-.045-1.392-.048-.314,0-.651,0-1,.019-.194,0-.391.021-.587.035a42.356,42.356,0,0,0-4.782.832c-.3.066-.6.141-.893.218s-.531.151-.8.228C301.739,159.4,300.87,159.751,300.87,159.751Z",
    transform: "translate(-297.571 -144.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M305,175.212c.372,1.227.691,2.45.959,3.634.353-2.144.51-4.346.51-4.346Z",
    transform: "translate(-300.603 -156.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M313.09,140.63c.566,1.485,1.358,4.251.46,5.462a5.429,5.429,0,0,0,4.073,1.2c1.836-.252,1.3-1.453.7-2.032-1.785-.112-1.961-1.392-1.86-2.638Z",
    transform: "translate(-306.544 -131.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-h",
    d: "M318.818,160.357a1.665,1.665,0,0,0-.135-2.628,1.8,1.8,0,0,0-.6.064s1.745,1.493-.242,2.019a9.75,9.75,0,0,1-4.3-1.3,1.474,1.474,0,0,0-.449.181c.547,1.1,4.267,1.958,4.267,1.958a1.825,1.825,0,0,1,.178-.5,20.339,20.339,0,0,1,.845,3.151,5.166,5.166,0,0,0,.741-.167,28.5,28.5,0,0,0-.8-3.13A1.886,1.886,0,0,1,318.818,160.357Z",
    transform: "translate(-306.544 -144.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M318.243,143.7l1.993,1.18a5.331,5.331,0,0,0,0,.874,2.148,2.148,0,0,1-1.884-1.219A2.389,2.389,0,0,1,318.243,143.7Z",
    transform: "translate(-310.326 -134.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M321.551,121.527c1.562-.6,1.4-4.591-1-4-1.626.4-1.459.89-1.161,1.934S320.563,121.9,321.551,121.527Z",
    transform: "translate(-311.025 -114.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M310.65,122.136c.489,2.059.669,3.289,1.908,4.174a2.815,2.815,0,0,0,4.4-2.229c.122-1.947-.7-4.989-2.88-5.462a2.885,2.885,0,0,0-3.427,3.518Z",
    transform: "translate(-304.689 -115.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M304.58,126.668c1.562-.6.962-4.517-1.443-3.919-1.626.4-1.344,1.328-.887,2.242C302.741,125.959,303.6,127.045,304.58,126.668Z",
    transform: "translate(-298.323 -118.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M308.094,108.718c-.406-1.039-2.524-1.788-2.909.231-1.78-.12-6.02,3.326-.986,3.313,2.489.627,6.177-.744,6.233-2.187A1.543,1.543,0,0,0,308.094,108.718Z",
    transform: "translate(-298.267 -107.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M308.422,135.864a1.86,1.86,0,0,0,1.164.8c.622.122.861-.465.627-1.044-.21-.531-.8-1.209-1.382-1.063A.822.822,0,0,0,308.422,135.864Z",
    transform: "translate(-302.99 -127.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M346.591,269.14l-3.438,1.108s-3.419-12.389-4.71-18.906c-.4-1.985-1.49-4.517-2.46-7.439-1.225-3.674-2.7-7.63-3.884-10.725-1.254-3.26-2.179-5.6-2.179-5.6l7.351-1.278s6.336,17.165,7.218,23.613C345.406,256.619,346.591,269.14,346.591,269.14Z",
    transform: "translate(-318.903 -194.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-d",
    d: "M341.994,258.1c-1.225-3.674-2.7-7.63-3.884-10.725l.6-1.743C340.78,247.633,341.973,254.373,341.994,258.1Z",
    transform: "translate(-324.917 -208.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M323.046,228.59s.6,18.364.332,24.6c-.292,6.839-2.378,20.191-2.378,20.191h-3.905s.871-12.107.8-18.778c-.093-7.6-2.572-24.671-2.572-24.671Z",
    transform: "translate(-308.182 -196.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M325.742,393.454h-4.6V392.08l5.143-.09Z",
    transform: "translate(-312.455 -316.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M381.892,383.049l-4.094,1.32-.428-1.323,4.556-1.546Z",
    transform: "translate(-353.746 -308.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M323.117,131.214c.029.17.143.292.266.266s.175-.173.146-.343-.143-.29-.266-.266S323.077,131.047,323.117,131.214Z",
    transform: "translate(-313.899 -124.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M330.343,129.963c.029.17.144.292.266.266s.175-.173.146-.343-.144-.292-.252-.266A.287.287,0,0,0,330.343,129.963Z",
    transform: "translate(-319.209 -123.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-i",
    d: "M328.12,131.64a6.089,6.089,0,0,0,1.063,1.307,1,1,0,0,1-.784.295Z",
    transform: "translate(-317.581 -125.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M323.8,138.524a1.421,1.421,0,0,1-1.063-.391.05.05,0,0,1,0-.072.053.053,0,0,1,.072,0A1.36,1.36,0,0,0,324,138.4a.053.053,0,0,1,.058.043.05.05,0,0,1-.04.058,1.774,1.774,0,0,1-.213.027Z",
    transform: "translate(-313.618 -129.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M320.236,128.3a.087.087,0,0,1-.093-.136,1.012,1.012,0,0,1,.752-.563.1.1,0,0,1,.021.2h0a.8.8,0,0,0-.579.441A.1.1,0,0,1,320.236,128.3Z",
    transform: "translate(-311.716 -122.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-e",
    d: "M330.7,126.255a.1.1,0,0,1-.088-.04.8.8,0,0,0-.638-.353.1.1,0,0,1-.106-.1.1.1,0,0,1,.1-.1,1,1,0,0,1,.813.436.1.1,0,0,1-.021.141A.093.093,0,0,1,330.7,126.255Z",
    transform: "translate(-318.866 -120.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M333.767,407.022a2.622,2.622,0,0,1-.561-.077.053.053,0,0,1-.04-.043.048.048,0,0,1,.021-.05c.074-.048.747-.47.986-.351a.168.168,0,0,1,.093.144.292.292,0,0,1-.093.266A.635.635,0,0,1,333.767,407.022Zm-.417-.149a1.017,1.017,0,0,0,.754-.04.186.186,0,0,0,.061-.181.064.064,0,0,0-.035-.061c-.125-.064-.507.12-.781.292Z",
    transform: "translate(-321.286 -327.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M333.22,405.587a.051.051,0,0,1-.027,0,.048.048,0,0,1-.024-.045c0-.027.027-.643.266-.845a.266.266,0,0,1,.213-.064h0a.167.167,0,0,1,.165.13c.056.239-.351.707-.569.826Zm.4-.863a.159.159,0,0,0-.114.045,1.143,1.143,0,0,0-.223.667c.213-.167.47-.531.436-.659,0-.013,0-.045-.074-.053Z",
    transform: "translate(-321.289 -325.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M392.76,396.895a.057.057,0,0,1-.045-.085c.077-.08.76-.755,1.063-.7a.17.17,0,0,1,.122.1h0a.287.287,0,0,1-.016.266c-.159.266-.768.377-1.113.417Zm.975-.685a2.122,2.122,0,0,0-.829.566,1.389,1.389,0,0,0,.887-.348.186.186,0,0,0,0-.175.053.053,0,0,0-.045-.04Z",
    transform: "translate(-365.008 -319.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M392.661,396.037h-.013a.045.045,0,0,1-.035-.037,1.485,1.485,0,0,1,.061-.882.374.374,0,0,1,.242-.17h0c.135-.029.2.027.221.077.112.218-.231.813-.441,1A.056.056,0,0,1,392.661,396.037Zm.327-1h-.05a.265.265,0,0,0-.178.125,1.174,1.174,0,0,0-.064.712c.2-.231.42-.683.353-.813A.061.061,0,0,0,392.988,395.038ZM392.927,395Z",
    transform: "translate(-364.909 -318.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M294.346,171.53c-.266.611-.531,1.27-.8,1.916s-.51,1.3-.747,1.95-.47,1.3-.672,1.955-.393,1.3-.547,1.947c-.072.321-.149.643-.2.956l-.043.236v-.011a.4.4,0,0,0-.1-.213c-.08-.05.037.1.244.2a4.781,4.781,0,0,0,.77.313,25,25,0,0,0,3.985.715l.085,1.594a16.312,16.312,0,0,1-2.256.266,12.368,12.368,0,0,1-2.349-.088,6.191,6.191,0,0,1-1.289-.311,4.073,4.073,0,0,1-.72-.343,2.814,2.814,0,0,1-.773-.685,2.415,2.415,0,0,1-.484-1.209,2.64,2.64,0,0,1,0-.321v-.226l.029-.3c.032-.4.093-.784.151-1.172a30.5,30.5,0,0,1,1.137-4.381c.242-.7.489-1.4.768-2.088s.55-1.358.882-2.056Z",
    transform: "translate(-288.452 -153.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-c",
    d: "M295.693,164.275c-1.105.6-1.873,4.19-1.873,4.19l3.268,2.009s.848-1.66,1.469-3.026C299.747,164.836,297.866,163.1,295.693,164.275Z",
    transform: "translate(-292.394 -148.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M315.053,212.393l2.149-.093-.954,2.046s-2.024-.122-1.756-1.092Z",
    transform: "translate(-307.556 -184.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgicon-gift-guy-g",
    d: "M323.547,213.7l-1.071,1.334-1.3-.707.951-2.038Z",
    transform: "translate(-312.485 -184.497)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftGuy);
export default __webpack_public_path__ + "static/media/gift-guy.922263d5.svg";
export { ForwardRef as ReactComponent };